import { isDefined } from "@clipboard-health/util-ts";
import { useFormContext } from "react-hook-form";

import { SingleSelectQuestion } from "../components/SingleSelectQuestion";
import { SurveyStepLayout } from "../components/SurveyStepLayout";
import { type ScreeningSurveyFormData } from "../lib/screeningSurveySchema";
import { experienceLevelLabels, experienceLevelValues } from "../lib/screeningSurveyTypes";

const options = experienceLevelValues.map((value) => ({
  value,
  label: experienceLevelLabels[value],
}));

interface HomeHealthExperienceStepProps {
  onContinue: () => void;
  onBack?: () => void;
  currentStep: number;
  totalSteps: number;
}

export function HomeHealthExperienceStep(props: HomeHealthExperienceStepProps) {
  const { onContinue, onBack, currentStep, totalSteps } = props;
  const { watch, setValue } = useFormContext<ScreeningSurveyFormData>();
  const value = watch("homeHealthExperience");

  return (
    <SurveyStepLayout
      currentStep={currentStep}
      totalSteps={totalSteps}
      title="How many years of Home Health experience do you have?"
      continueDisabled={!isDefined(value)}
      onBack={onBack}
      onContinue={onContinue}
    >
      <SingleSelectQuestion
        options={options}
        value={value}
        onChange={(v) => {
          setValue("homeHealthExperience", v);
        }}
      />
    </SurveyStepLayout>
  );
}
